import React from "react"

import { StyledSelect } from "./StyledSelect"
import Icon from "components/UI/atoms/Icon"

import { ISelectProps } from "./SelectTypes"
import { Box, Text, FormLabel } from "@chakra-ui/react"

const SelectInput: React.FC<ISelectProps> = ({ value, id, styles, name, label, options, placeholder, onChange, isLoading, isDisabled, onBlur, inputStyles, maxMenuHeight, error, selectWidth, menuPlacement = "auto" }) => {

  const DropdownIndicator = () => {
    return (
      <Box className="react-select-dropdown-icon">
        <Icon
          name="dropdown"
          iconStyles={{ fill: "#00000", width: "10px", height: "10px" }}
        />
      </Box>
    )
  }


  const mergedStyles = {
    ...styles,
    menuPortal: (base: any) => ({
      ...base,
      zIndex: 9999, // Ensure the dropdown appears above other elements
    }),

  };


  return (
    <>
      {label && (
        <FormLabel htmlFor="name" fontSize="base" color={`${error ? "error" : "main_text_color"}`}>
          {label}
        </FormLabel>
      )}
      <StyledSelect
        id={id}
        value={options?.find((option: any) => option.value === value)}
        styles={mergedStyles}
        isSearchable={false}
        name={name}
        onChange={onChange}
        onBlur={onBlur}
        options={options}
        placeholder={placeholder}
        className="react-select"
        classNamePrefix="react-select"
        components={{ DropdownIndicator }}
        error={error}
        isLoading={isLoading}
        isDisabled={isDisabled}
        width={selectWidth}
        // menuPosition="fixed"   //fix: While only one reservation is in ReservationsTable, box and washer dropdown will open fully with "fixed"
        menuPlacement={menuPlacement}
        {...inputStyles}
        maxMenuHeight={maxMenuHeight}
        menuPortalTarget={document.body}
      />
      {error && (
        <Text color="error" fontSize="base">{error}</Text>
      )}
    </>
  )
}

export default SelectInput
